import React from 'react';
import LegalPage from './LegalPage';
import TerminosContent from '../components/legal/TerminosContent';

export default function Terminos() {
  return (
    <LegalPage
      eyebrow="documento legal"
      title="Términos y condiciones de uso"
      lastUpdate="5 de junio de 2026"
      activeSlug="terminos"
    >
      <TerminosContent />
    </LegalPage>
  );
}
